import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { PostHubService } from '../post-hub.service'
import { ActivatedRoute, Router } from '@angular/router';
import {
    MatSnackBar,
    MatSnackBarHorizontalPosition,
    MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
@Component({
    selector: 'app-post-detail',
    templateUrl: './post-detail.component.html',
    styleUrls: ['./post-detail.component.css'],
})
export class PostDetailComponent implements OnInit {
    postId = "";
    botId = "";
    postDetails: any;
    isReadMore = true;
    reactionCount = 0;
    questionCorrectOptionName = "";
    isSchedulePost = false;
    pollVoters: string[] = [];
    displayedVoters: string[] = [];
    showAllVoters = false;
    currentPage = 1;
    itemsPerPage = 10;
    totalVoters = 0;
    ngOnInit(): void {
        this.botId = this.activatedRoute.snapshot.params.botId;
        this.postId = this.activatedRoute.snapshot.params.postId;
        this.isSchedulePost = this.activatedRoute.snapshot.params.isSchedule === 'Scheduled'
        this.getPostDetailsByBotandPostId();
    }
    constructor(
        private postHubService: PostHubService,
        private activatedRoute: ActivatedRoute
    ) { }

    getPostDetailsByBotandPostId() {

        this.postHubService.getPostDetailsByPostId(this.botId, this.postId, this.isSchedulePost).subscribe(
            (res) => {
                this.postDetails = res.body;
                if (this.postDetails?.type == 'poll' || this.postDetails?.type == 'question') this.handlePollType();
                else this.handlePostType();
            }
        )

    }

    loadPollVoters() {
        this.postHubService.getPollVoters(this.postId, this.botId).subscribe(
            (res) => {
                this.pollVoters = res.data;
                this.totalVoters = this.pollVoters.length;
                this.displayedVoters = this.pollVoters.slice(0, 5);
            }
        );
    }

    toggleVotersView() {
        this.showAllVoters = !this.showAllVoters;
        if (this.showAllVoters) {
            this.updateDisplayedVoters();
        }
    }

    updateDisplayedVoters() {
        const startIndex = (this.currentPage - 1) * this.itemsPerPage;
        const endIndex = startIndex + this.itemsPerPage;
        this.displayedVoters = this.pollVoters.slice(startIndex, endIndex);
    }

    nextPage() {
        if (this.currentPage * this.itemsPerPage < this.totalVoters) {
            this.currentPage++;
            this.updateDisplayedVoters();
        }
    }

    prevPage() {
        if (this.currentPage > 1) {
            this.currentPage--;
            this.updateDisplayedVoters();
        }
    }

    get totalPages(): number {
        return Math.ceil(this.totalVoters / this.itemsPerPage);
    }

    handlePostType() {
        for (const reactionKey in this.postDetails?.reactions) {
            this.reactionCount += this.postDetails?.reactions[reactionKey];
        }

    }
    formatReactionKey(key: any): string {
        if (typeof key === 'string') {
            return key.charAt(0).toUpperCase() + key.slice(1);
        }
        return '';
    }
    handlePollType() {
        if(this.postDetails.type === 'poll') {
            this.loadPollVoters();
        }
        for (let i = 0; i < this.postDetails?.options.length; i++) {
            const option = this.postDetails.options[i];
            if(this.postDetails?.type=='question'){
                this.reactionCount += this.postDetails?.options[i].answers;
                if(this.postDetails?.options[i]['id']===this.postDetails?.correct_option_uuid){
                    option.isCorrect = option.id === this.postDetails?.correct_option_uuid;
                    if(option.isCorrect) {
                        this.questionCorrectOptionName = option.text;
                    }
                    this.questionCorrectOptionName = this.postDetails?.options[i]['text']
                }
            } else {
                this.reactionCount += this.postDetails?.options[i]['votes'];
            }
        }
    }

    calculatePercentage(votes,totalVotes){
        return (totalVotes === 0 ? 0 : (votes / totalVotes) * 100);
    }
}